export default "__VITE_ASSET__DcY_gi3V__"